import Cookies from "js-cookie";
import { loginWithToken } from "../services/authService";

export const getUrlToken = (search = window.location.search) =>
  new URLSearchParams(search).get("token")?.trim() || "";

export const storeAuthTokens = (result = {}) => {
  if (result.accessToken) {
    Cookies.set("accessToken", result.accessToken, { expires: 1 });
  }
  if (result.refreshToken) {
    Cookies.set("refreshToken", result.refreshToken, { expires: 7 });
  }
};

export const clearTokenFromUrl = (path = "/dashboard") => {
  window.history.replaceState({}, "", path);
};

export const getPasswordResetPath = (token) =>
  `/auth/reset-password?token=${encodeURIComponent(token)}`;

export const tryLoginWithUrlToken = async (token) => {
  if (!token) {
    return { success: false };
  }

  try {
    const response = await loginWithToken(token);
    const { isSuccess, result } = response ?? {};

    if (isSuccess && result?.accessToken) {
      storeAuthTokens(result);
      return { success: true };
    }
  } catch (error) {
    console.error("Token login failed:", error);
  }

  return { success: false };
};
